module.exports = __webpack_public_path__ + "static/media/step-2.dd9eb2ca.png";